import React from 'react';
import MapContainer from './components/MapContainer/MapContainer';

function App() {
  return (
    <div className="App">
      <MapContainer />
    </div>
  );
}

export default App;
